<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { User, Star, Setting, Lock, School } from '@element-plus/icons-vue';
import request from '@/utils/request';
import { getSchoolDictList, updateSchoolDict } from '@/utils/api';
import { useUserStore } from '@/store/user';
const userStore = useUserStore();

const route = useRoute();
const router = useRouter();
const formRef = ref(null);
const loading = ref(false);
const currentRole = ref('student'); // 默认显示学生登录


onMounted(() => {
  
})

// 表单数据
const form = reactive({
  username: '',    // 用户名（通用）
  password: '',    // 密码（通用）
  // verifyCode: ''   // 验证码（仅管理员）
  school: ''
});

// 角色配置信息 - 集中管理不同角色的差异
const roleConfig = computed(() => {
  const configs = {
    student: {
      title: '用户登录',
      usernamePlaceholder: '请输入用户名',
      apiUrl: '/auth/login',
      redirectPath: '/my-work-list',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    },
    reviewer: {
      title: '用户登录',
      usernamePlaceholder: '请输入用户名',
      apiUrl: '/auth/login',
      redirectExpertPath: '/review',
      redirectStudentPath: '/work-list',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    },
    employee: {
      title: '用户登录',
      usernamePlaceholder: '请输入用户名',
      apiUrl: '/auth/login',
      redirectPath: '/emp-sti-manage',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    },
    admin: {
      title: '用户登录',
      usernamePlaceholder: '请输入用户名',
      apiUrl: '/auth/login',
      redirectPath: '/sti-manage',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        // verifyCode: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
      }
    },
    newUser: {
      title: '学生注册',
      usernamePlaceholder: '请输入用户名',
      // apiUrl: '/auth/student/register',
      apiUrl: '/auth/register',
      redirectPath: '/login',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  };
  return configs[currentRole.value];
});

// 切换角色
const switchRole = (role) => {
  currentRole.value = role;
  // 清空当前表单
  Object.keys(form).forEach(key => {
    form[key] = '';
  });
  // 重置表单验证状态
  if (formRef.value) {
    formRef.value.clearValidate();
  }
};

// 处理返回
// const handleBack = () => {
//   router.push('/');
// }


// 处理登录
const handleLogin = async () => {
  try {
    loading.value = true;
    // 表单验证
    await formRef.value.validate();
    
    // 准备登录数据
    const loginData = {
      username: form.username,
      password: form.password,
      role: currentRole.value
    };
    
    // 管理员添加验证码
    // if (currentRole.value === 'admin') {
    //   loginData.verifyCode = form.verifyCode;
    // }
    
    // 发送登录请求
    // const response = {
    //   token: '123456',
    //   user: {
    //     id: 1,
    //     username: form.username,
    //     role: currentRole.value
    //   }
    // }
    // xwj-TODO:上边先设一个模拟数据，后边再用真实数据替换
    const response = await request.post(roleConfig.value.apiUrl, loginData);
    currentRole.value = response.data.user_type


    
    // 存储登录状态
    // localStorage.setItem('token', response.data.access_token);
    // // localStorage.setItem('token', response.token);
    // localStorage.setItem('user', JSON.stringify({
    //   ...response.data,
    //   role: currentRole.value
    // }));

    userStore.setToken(response.data.access_token);
    userStore.setUser({
      ...response.data,
      role: currentRole.value
    });

    console.log('登录成功', localStorage.getItem('user'));
    
    ElMessage.success('登录成功');

    // 获取重定向参数
    const routeQuery = router.currentRoute.value.query;
    console.log('重定向参数', routeQuery);
    // const redirectParam = routeQuery.redirect;
    const redirectParam = route.query.redirect;

    if(redirectParam){
      // 如果有重定向参数，跳转回原页面
      // router.push(redirectParam);
      router.replace(redirectParam);
    }else {
      if (currentRole.value === 'reviewer') {
        // router.push(roleConfig.value.redirectExpertPath);
        router.push('/')
        window.open(roleConfig.value.redirectExpertPath, '_blank');
      }else{
        // router.push(roleConfig.value.redirectPath);
        router.push('/')
        window.open(roleConfig.value.redirectPath, '_blank');
      }
    }
    
  } catch (error) {
    if (error.name !== 'ValidationError') {
      ElMessage.error('登录失败: ' + (error.response?.data?.message || '未知错误'));
    }
  } finally {
    loading.value = false;
  }
};

const schools = ref([
  {
    value: '1',
    label: '清华大学'
  },
  {
    value: '2',
    label: '北京大学'
  },
  {
    value: '3',
    label: '中国人民大学'
  }
])

const handleRegister = async () => {
  switchRole('newUser');
  getSchoolDictList().then(res => {
    if(res.success){
      schools.value = res.data
    }
  })
}

const submitRegister = async () => {
  try {
    loading.value = true;
    // 表单验证
    await formRef.value.validate();
    
    // 准备注册数据
    const registerData = {
      username: form.username,
      password: form.password
    };
    
    // 发送注册请求
    const response = await request.post('/auth/register', registerData);
    
    ElMessage.success('注册成功');
    router.push('/login');
  } catch (error) {
    console.log('注册失败', error);
    if (error.name) {
      ElMessage.error('注册失败: ' + (error.response?.data?.message || '未知错误'));
    }
  } finally {
    loading.value = false;
  }
}

const toLogin = () => {
  switchRole('student');
}

const isAdding = ref(false);
const optionName = ref('')
const onAddOption = () => {
  isAdding.value = true
}
const onConfirm = () => {
  console.log('添加学校onConfirm', optionName.value)
  if (optionName.value) {
    // schools.value.push({
    //   label: optionName.value,
    //   value: optionName.value,
    // })
    updateSchoolDict({
      // type: 'school',
      // items: schools.value
      name: optionName.value,
    }).then(res => {
      if(res.success){
        ElMessage.success('添加学校成功')
        schools.value = res.data
      }else{
        ElMessage.error('添加学校失败')
      }
    })
    clear()
  }
}

const clear = () => {
  optionName.value = ''
  isAdding.value = false
}


</script>

<template>
  <div class="login-container">
    <!-- 角色选择器 -->
    <!-- <div class="role-tabs">
      <div 
        class="role-tab" 
        :class="{ active: currentRole === 'student' }"
        @click="switchRole('student')"
      >
        <el-icon><User /></el-icon>
        <span>学生</span>
      </div>
      <div 
        class="role-tab" 
        :class="{ active: currentRole === 'reviewer' }"
        @click="switchRole('reviewer')"
      >
        <el-icon><Star /></el-icon>
        <span>评审员</span>
      </div>
      <div 
        class="role-tab" 
        :class="{ active: currentRole === 'admin' }"
        @click="switchRole('admin')"
      >
        <el-icon><Setting /></el-icon>
        <span>管理员</span>
      </div>
    </div> -->

    <!-- 登录卡片 -->
    <div class="login-card">
      <div class="login-title">{{ roleConfig.title }}</div>
      <el-form ref="formRef" :model="form" :rules="roleConfig.rules" class="login-form">
        <!-- 用户名输入 -->
        <el-form-item prop="username">
          <el-input 
            v-model="form.username" 
            :placeholder="roleConfig.usernamePlaceholder" 
            :prefix-icon="User"
          ></el-input>
        </el-form-item>
        
        <!-- 密码输入 -->
        <el-form-item prop="password">
          <el-input 
            v-model="form.password" 
            type="password" 
            placeholder="请输入密码" 
            :prefix-icon="Lock"
          ></el-input>
        </el-form-item>

        <el-form-item prop="school" v-if="currentRole === 'newUser'">
          <el-select v-model="form.school" placeholder="请选择学校" filterable>
            <template #prefix>
              <el-icon><School /></el-icon>
            </template>
            <el-option v-for="item in schools" :key="item.id" :label="item.name" :value="item.id"/>
            <template #footer>
              <el-button v-if="!isAdding" text bg size="small" @click="onAddOption">
                添加学校
              </el-button>
              <template v-else>
                <el-input v-model="optionName" class="option-input" placeholder="输入学校名字" size="small"/>
                <el-button type="primary" size="small" @click="onConfirm">确认</el-button>
                <el-button size="small" @click="clear">取消</el-button>
              </template>
            </template>
          </el-select>
        </el-form-item>
        
        <!-- 管理员专用验证码 -->
        <!-- <el-form-item v-if="currentRole === 'admin'" prop="verifyCode">
          <el-input 
            v-model="form.verifyCode" 
            placeholder="请输入验证码" 
            prefix-icon="Key"
          ></el-input>
        </el-form-item> -->
        
        <!-- 登录按钮 -->
        <el-form-item>
          <div class="btn">
            <!-- <el-button v-if="currentRole !== 'newUser'"
              class="login-btn" @click="handleBack"
              :loading="loading"
            >
              返回
            </el-button> -->
            <el-button v-if="currentRole !== 'newUser'"
              type="primary" 
              class="login-btn" 
              @click="handleLogin"
              :loading="loading"
            >
              登录
            </el-button>
            <el-button v-if="currentRole === 'student' && false" 
              class="login-btn" @click="handleRegister" :loading="loading">
              注册
            </el-button>
            <el-button v-if="currentRole === 'newUser'" 
              type="primary" 
              class="login-btn" @click="submitRegister" :loading="loading">
              注册
            </el-button>
          </div>
        </el-form-item>

        <div v-if="currentRole === 'newUser'" >
          <el-button link @click="toLogin" type="primary">
            注册成功，去登录
          </el-button>
        </div>
      </el-form>
    </div>
    
    <!-- 返回首页链接 -->
    <!-- <div class="back-home">
      <el-button type="text" @click="$router.push('/')">
        <el-icon><ArrowLeft /></el-icon>返回首页
      </el-button>
    </div> -->
  </div>
</template>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* min-height: 100vh; */
  /* height: calc(100vh - 160px);
  justify-content: center; */
  padding: 60px 20px;
  background-color: #f5f7fa;
}

/* 角色选择器样式 */
.role-tabs {
  display: flex;
  margin-bottom: 30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.role-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
}

.role-tab.active {
  color: #165DFF;
  font-weight: 500;
  position: relative;
}

.role-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #165DFF;
}

.role-tab:hover:not(.active) {
  color: #333;
}

/* 登录卡片样式 */
.login-card {
  width: 400px;
  padding: 30px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.login-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #165DFF;
  margin-bottom: 30px;
}

.login-form {
  margin-top: 20px;
}

.btn{
  width: 100%;
  display: flex;
  justify-content: center;
}

.login-btn {
  /* width: 100%; */
  width: 30%;
  height: 45px;
  font-size: 16px;
}

/* 返回首页按钮 */
/* .back-home {
  margin-top: 20px;
} */


.option-input {
  width: 100%;
  margin-bottom: 10px;
}
</style>